document.addEventListener('DOMContentLoaded', () => {
  const cartItemsContainer = document.querySelector('.cart-items tbody');
  let observer;
  let isUpdating = false;

  const freeProductId = 45079106912450;

  hideFreeProductControls();

  attachCheckboxEventListeners();

  if (cartItemsContainer) {
    observer = new MutationObserver(() => {
      if (isUpdating) return;

      console.log('Cart items updated, reattaching event listeners...');
      isUpdating = true;

      observer.disconnect();
      attachCheckboxEventListeners();
      observer.observe(cartItemsContainer, { childList: true, subtree: true });

      isUpdating = false;
    });

    observer.observe(cartItemsContainer, { childList: true, subtree: true });
  }

  attachCheckboxEventListeners();

  function attachCheckboxEventListeners() {
    console.log("Attaching events to checkboxes");
    const subscribeCheckboxes = document.querySelectorAll('.subscribe-checkbox');

    subscribeCheckboxes.forEach((checkbox) => {
      if (checkbox.dataset.eventsAttached === "true") return;

      checkbox.dataset.eventsAttached = "true";
      checkbox.addEventListener('change', handleCheckboxChange);

      const productHandle = checkbox.dataset.handle;
      const productKey = checkbox.dataset.key;
     
     
      
      if (!productHandle) {
        console.error('Product handle not found for checkbox');
        return;
      }

       // Find the cart row that matches this product key
        const cartItemRow = document.querySelector(`.cart-item__details[data-key="${productKey}"]`);
         // Extract the Reorder Plan ID (selling_plan) from the product link
        let selectedPlanId = null;
        if (cartItemRow) {
            const productLink = cartItemRow.querySelector('a[href*="selling_plan="]');
            if (productLink) {
                const urlParams = new URLSearchParams(productLink.getAttribute('href').split('?')[1]);
                selectedPlanId = urlParams.get('selling_plan');
            }
        }
       console.log("selectedPlanId "+selectedPlanId);

      fetch(`/products/${productHandle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const sellingPlans = product.selling_plan_groups || [];
          const dropdown = document.querySelector(`.reminder-options[data-key="${checkbox.dataset.key}"]`);
          const phoneInputContainer = document.querySelector(`.phone-input[data-key="${checkbox.dataset.key}"]`);
       


          if (dropdown && sellingPlans.length > 0) {
            dropdown.innerHTML = '<option value="">--please select--</option>';
            sellingPlans.forEach((group) => {
              group.selling_plans.forEach((plan) => {
                const deliveryFrequency = plan.options[0]?.value || "N/A";
                const isSelected = (selectedPlanId && selectedPlanId == plan.id) ? 'selected' : '';// Preselect previous plan
                if (selectedPlanId == plan.id){
                  console.log("found!");
                }
                dropdown.innerHTML += `
                  <option 
                    value="${plan.id}" 
                    data-plan-name="${plan.name}" 
                    data-delivery-frequency="${deliveryFrequency}"
                    ${isSelected}>
                    ${plan.name} - ${deliveryFrequency}
                  </option>
                `;
              });
            });

            if (checkbox.checked) {
              dropdown.classList.remove('hidden');
              phoneInputContainer.classList.remove("hidden");
              const selectedPlanId = dropdown.dataset.selectedPlanId;
              if (selectedPlanId) {
                dropdown.value = selectedPlanId;
              }
            } else {
              dropdown.classList.add('hidden');
              phoneInputContainer.classList.add("hidden");
            }
          }
        })
        .catch((error) => console.error('Error fetching product details:', error));
    });
  }

  function formatPhoneNumber(phone) {
    phone = phone.trim(); // Remove leading/trailing spaces
    if (!phone.startsWith('+1')) {
        phone = '+1' + phone;
    }
    return phone;
}

  
  function handleCheckboxChange(event) {
    const checkbox = event.target;
    const productKey = checkbox.dataset.key;
    const productId = checkbox.dataset.id;
    const cartItemDetails = document.querySelector(`.cart-item__details[data-key="${productKey}"]`);
    const regularVariantId = cartItemDetails?.getAttribute('data-id');
    const dropdown = document.querySelector(`.reminder-options[data-key="${productKey}"]`);
     const phoneInputContainer = document.querySelector(`.phone-input[data-key="${checkbox.dataset.key}"]`);

   // var phoneValue = formatPhoneNumber(phoneInputContainer.value);
    
    if (checkbox.checked) {
      dropdown.classList.remove('hidden');
      phoneInputContainer.classList.remove("hidden");
      dropdown.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        handleSubscription(
          regularVariantId,
          productKey,
          selectedOption.value,
          selectedOption.dataset.planName,
          selectedOption.dataset.deliveryFrequency,
          formatPhoneNumber(phoneInputContainer.value)
          
        );
      });
    } else {
      dropdown.classList.add('hidden');
      phoneInputContainer.classList.add("hidden");
      if (regularVariantId) {
        removeSubscription(productKey, productId, regularVariantId);
      } else {
        console.error("Regular Variant ID is missing!");
      }
    }
  }

  function handleSubscription(productId, productKey, planId, planName, planInterval,phoneNumber) {
    console.log("Switching to subscription:", { productId, productKey, planId, planName, planInterval });

     // Find the current quantity of the item in the cart
  const quantityInput = document.querySelector(`input.quantity__input[data-quantity-variant-id="${productId}"]`);
  const currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1; // Default to 1 if not found
 // const phoneNumber  = document.querySelector("#phone-input").value;


    fetch(`/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [productKey]: 0 }
        }),
      })
      .then(() => {
        // Add subscription product
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: productId,
            quantity: currentQuantity,
            selling_plan: planId,
            properties: {
            //  'Re-order Reminder Plan ID': planId,
             // 'Plan Name': planName,
            //  'Re-order Reminder Interval': planInterval,
              'Phone Number': phoneNumber
            },
          }),
        });
      })
      .then(response => response.json())
      .then(subscriptionItem => {
        console.log("Subscription added:", subscriptionItem);
        updateCartUI(subscriptionItem, "subscription");
      
        //  Add Re-order Text Reminders product
      /* return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeProductId, // <-- this should be the VARIANT ID
            quantity: 1
          })
        });
        */
      })
     /* .then(response => response.json())
      .then(reminderItem => {
        console.log("Reminder item added:", reminderItem);
        
      })
    */
      .catch(error => console.error("Error handling subscription:", error));

  }

function removeSubscription(productKey, productId, regularVariantId) {
  console.log("Switching back to regular product:", { productKey, productId, regularVariantId });

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const updates = {};
      updates[productKey] = 0; // Remove subscription
/*
      const secondVariantId = freeProductId;
      const secondItem = cart.items.find(item => item.variant_id === secondVariantId);

      if (secondItem) {
        const newQuantity = secondItem.quantity - 1;
        if (newQuantity > 0) {
          updates[secondItem.key] = newQuantity;
        } else {
          updates[secondItem.key] = 0; // Remove if it reaches 0
        }
      }
*/
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: regularVariantId,
          quantity: 1,
        }),
      });
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Regular product added:", data);
      updateCartUI(data, "regular"); // Your own UI function
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch((error) => console.error("Error updating cart:", error));
}



// Phone Number Validation on Input Change
  const phoneInput = document.querySelector("#phone-input");
  const errorMessage = document.querySelector(".error-message");

  function validatePhone(phone) {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // Validates international numbers
    return phoneRegex.test(phone);
  }

if(phoneInput){
  phoneInput.addEventListener("input", function () {
    if (!validatePhone(this.value)) {
      errorMessage.classList.remove("hidden");
    } else {
      errorMessage.classList.add("hidden");
    }
  });
}
  
  // this is for mini cart
  //const checkoutForm = document.querySelector("#CartDrawer-Form"); // Shopify's checkout form

   // this is for regular cart
  const checkoutForm = document.querySelector(".cart__contents"); // Shopify's checkout form
  const originalSubmitButton = document.getElementById("checkout");


  // Prevent checkout if phone number is missing when subscription is selected
  
checkoutForm.addEventListener("submit", async function (event) {
    const checkedSubscription = document.querySelector(".subscribe-checkbox:checked");
    const phoneNumber = phoneInput.value.trim();
    const subscriptionInterval = document.querySelector(".bundle-selling_plan_select");

    if (checkedSubscription && !validatePhone(phoneNumber)) {
        event.preventDefault(); 
        alert("Please enter a valid phone number before checking out.");
    } else if (checkedSubscription && !subscriptionInterval.value.trim()) {
        event.preventDefault(); 
        alert("Please select re-order reminder interval.");
    } else {
        event.preventDefault(); // Prevent immediate form submission

        // this is for allowing coupons to work
     
    
          console.log("button clicked");
        
    
          try {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
    
            const WEEK_PLAN_GROUP_ID = 319872041154; // ← your real Week Plan group ID here
    
            for (const item of cart.items) {
              const productId = item.product_id;
              const sellingPlanAllocation = item.selling_plan_allocation;
    
            
    
              const isOneTimePurchase = typeof sellingPlanAllocation === 'undefined';
              console.log ("isOneTimePurchase "+isOneTimePurchase);
              const isSmsReminderSubscription = sellingPlanAllocation?.selling_plan?.name?.includes("SMS Reminder");
    
              if (isOneTimePurchase || isSmsReminderSubscription) {
                console.log("Adding product to Reminders collection:", productId);
                await fetch(`https://shop-app.dropstreet.co/public/product-to-collection.php?shop=wells-coffee-company.myshopify.com&product_id=${encodeURIComponent(productId)}`);
              } else {
                console.log("Skipping product:", productId);
              }
            }
    
            // Redirect to checkout
            window.location.href = '/checkout';
    
          } catch (error) {
            console.error('Error before checkout:', error);
            alert('Something went wrong while preparing your checkout.');
          }
      
    }
});

// Submit form when "OK" button is clicked
/*document.getElementById("confirm-submit").addEventListener("click", function () {
  document.getElementById("confirmation-overlay").style.display = "none";

});
  */ 
  

 function updateCartUI(cartData, prType) {
   console.log("prType: "+prType);
  var cartItemsContainer = document.querySelector(`.selling-plan-details[data-id="${cartData.id}"]`);
   var propertyContainer = document.querySelector(`.property-details[data-id="${cartData.id}"]`);



  if (cartData.id && prType=="subscription") {
    console.log("Cart data for single item:", cartData);

  
    if (cartItemsContainer) {
      console.log("adding plans info", cartData.id);

      cartItemsContainer.innerHTML =  Object.entries(cartData.properties)
         //   .filter(([key]) => key === "Phone Number") // Filter only "Re-order Interval"
            .map(([key, value]) => `
              <div class="product-option">
                <dt>${key}:</dt>
                <dd>${value}</dd>
              </div>
            `).join('');
   
    } 
 

  // Reattach event listeners to the updated items
 // attachCheckboxEventListeners();
}else{
  // regular product
    cartItemsContainer.innerHTML = '';
    propertyContainer.innerHTML = '';
}
}


   // Wait for Bold to modify the select options
    setTimeout(function () {
      const selectElements = document.querySelectorAll(".reminder-options");

      selectElements.forEach(selectElement => {
        const options = selectElement.querySelectorAll("option");

        options.forEach(option => {
          // Remove options that don't contain the word "reminder"
          const planName = option.textContent.toLowerCase();
          if (!planName.includes("please select") && !planName.includes("reminder")) {
            option.remove(); // Remove options that don't include "reminder"
          }
        });
      });
    }, 1000); // Adjust this timeout to suit when Bold app finishes modifying the DOM

function hideFreeProductControls(){
  const idsToHide = [freeProductId];
  idsToHide.forEach(id => {
    const el = document.querySelector(`.cart__remove[data-id="${id}"]`);
    if (el) {
      el.style.setProperty('display', 'none', 'important');
    }
  });
  
}
  
  
  function fetchProductDetails(productHandle, callback) {
  fetch(`/products/${productHandle}.js`)
    .then((response) => response.json())
    .then((productData) => {
      callback(productData);
    })
    .catch((error) => {
      console.error("Error fetching product details:", error);
    });
}
 function initializeCartDrawerToggle() {
    const cartToggle = document.querySelector('.header__icon--cart');
    const cartDrawer = document.querySelector('.drawer');

    if (cartToggle && cartDrawer) {
      cartToggle.addEventListener('click', () => {
        cartDrawer.classList.toggle('active');

        // Once the cart drawer is opened, reattach event listeners for checkboxes
        if (cartDrawer.classList.contains('active')) {
        //  attachCheckboxEventListeners();
        }
      });
    }
  }

// === SUBSCRIPTION REMOVAL MONITORING ===


function monitorSubscriptionRemoval() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const cartSubscriptionItems = cart.items.filter(item => item.selling_plan_allocation);

      // === REMOVE FREE PRODUCT IF NO SUBSCRIPTIONS LEFT ===
      if (cartSubscriptionItems.length === 0) {
        const freeProduct = cart.items.find(item => item.variant_id === freeProductId);
        if (freeProduct) {
          console.log('No subscriptions left. Removing free product...');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: freeProduct.key,
              quantity: 0
            })
          })
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
               hideFreeProductVisually();
          });
        }
      }
    })
    .catch(console.error);
}
function hideFreeProductVisually() {
 

  // Try to find the cart line item that matches the free product variant ID
  const cartItems = document.querySelectorAll('.cart-item');
  cartItems.forEach((item) => {
     const detailElement = item.querySelector('.cart-item__details');
    const variantId = detailElement.getAttribute('data-id') || item.dataset.variantId;
    
    
    if (Number(variantId) === freeProductId) {
      item.style.display = 'none'; // 💨 hide the item visually
      console.log('Free product hidden from cart.');
    }
  });
}


  
function updateCartUIVisual() {
  fetch('/?section_id=main-cart-items')
    .then((res) => res.text())
    .then((html) => {
      const tempDom = new DOMParser().parseFromString(html, 'text/html');
      const updatedCartItems = tempDom.querySelector('[data-id="main-cart-items"]');
      console.log(updatedCartItems);

      const currentCartItems = document.querySelector('.cart__items');
      console.log(currentCartItems);
      if (updatedCartItems && currentCartItems) {
        currentCartItems.innerHTML = updatedCartItems.innerHTML;
        console.log("Cart visually updated.");
      }
    })
    .catch(console.error);
}
  

// Start monitoring every 1.5 seconds
//setInterval(monitorSubscriptionRemoval, 1500);
  
});